
import Intercom from '@intercom/messenger-js-sdk';
import { mapState } from 'vuex';

export default {
  name: 'IntercomChat',
  computed: {
    ...mapState('user', ['user', 'currentAccount']),
  },
  mounted() {
    Intercom({
      app_id: 'blgi3fe3',
      alignment: 'left',
      user_id: this.currentAccount.uuid, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
      name: this.user.name, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
      email: this.user.email, // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
      created_at: this.currentAccount?.created_at, // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
      company: {
        company_id: this.currentAccount.firm.uuid,
        created_at: this.currentAccount.firm.created_at,
        name: this.currentAccount.firm.name,
      },
    });
  },
};
